import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box, Link, Typography } from '@mui/material';

// ----------------------------------------------------------------------

const Logo = forwardRef(({ disabledLink = false, sx, ...other }, ref) => {
  const logo = (
    <Box component="img" src="/assets/logo/logo.svg" sx={{ width: 60, height: 60, cursor: 'pointer', ...sx }} />
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  return (
    <Link
      to="/"
      component={RouterLink}
      sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 1, textDecoration: 'none' }}
    >
      <Box>{logo}</Box>
      <Typography sx={{ color: '#2993f1', fontWeight: 600, fontSize: 24 }}>SUV OL</Typography>
    </Link>
  );
});

Logo.propTypes = {
  sx: PropTypes.object,
  disabledLink: PropTypes.bool,
};

export default Logo;
